import React from "react";
import Navbar from "../../components/common/Navbar/Navbar";
import { MARKETING_HOME } from "./marketingHome";

type AuthShellNavbarProps = {
  anim?: string;
  variant?: string;
  triggerZoomOut: (cx: number, cy: number, to?: string, delay?: number) => void;
};

/** Logo-only auth navbar — same chrome as login/register. */
const AuthShellNavbar: React.FC<AuthShellNavbarProps> = ({
  anim = "auth-animated",
  variant = "",
  triggerZoomOut,
}) => (
  <div className={`auth-nav-overlay ${anim} ${variant}`}>
    <Navbar
      onZoomNavigate={(e, to) => {
        const r = e.currentTarget.getBoundingClientRect();
        const dest = to === "/" ? MARKETING_HOME : to;
        triggerZoomOut(r.left + r.width / 2, r.top + r.height / 2, dest);
      }}
    />
  </div>
);

export default AuthShellNavbar;
